import AsyncStorage from '@react-native-async-storage/async-storage';

interface CacheItem<T> {
  data: T;
  timestamp: number;
  expiresIn: number;
}

const CACHE_PREFIX = '@baratao_cache:';

// 7 dias em milissegundos
export const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Salva dados no cache com tempo de expiração
 */
export async function setCache<T>(
  key: string,
  data: T,
  expiresIn: number = SEVEN_DAYS_MS,
): Promise<void> {
  try {
    const cacheItem: CacheItem<T> = {
      data,
      timestamp: Date.now(),
      expiresIn,
    };
    await AsyncStorage.setItem(
      `${CACHE_PREFIX}${key}`,
      JSON.stringify(cacheItem),
    );
  } catch (error) {
    console.error('Erro ao salvar cache:', error);
  }
}

/**
 * Recupera dados do cache se ainda válidos
 */
export async function getCache<T>(key: string): Promise<T | null> {
  try {
    const cached = await AsyncStorage.getItem(`${CACHE_PREFIX}${key}`);
    if (!cached) {
      return null;
    }

    const cacheItem: CacheItem<T> = JSON.parse(cached);
    const isExpired = Date.now() - cacheItem.timestamp > cacheItem.expiresIn;

    if (isExpired) {
      await AsyncStorage.removeItem(`${CACHE_PREFIX}${key}`);
      return null;
    }

    return cacheItem.data;
  } catch (error) {
    console.error('Erro ao recuperar cache:', error);
    return null;
  }
}

/**
 * Remove um item específico do cache
 */
export async function removeCache(key: string): Promise<void> {
  try {
    await AsyncStorage.removeItem(`${CACHE_PREFIX}${key}`);
  } catch (error) {
    console.error('Erro ao remover cache:', error);
  }
}

/**
 * Limpa todo o cache do app
 */
export async function clearAllCache(): Promise<void> {
  try {
    const keys = await AsyncStorage.getAllKeys();
    const cacheKeys = keys.filter(key => key.startsWith(CACHE_PREFIX));
    await AsyncStorage.multiRemove(cacheKeys);
  } catch (error) {
    console.error('Erro ao limpar cache:', error);
  }
}

// Chaves de cache
export const CACHE_KEYS = {
  MASTERCLIN_DESTAQUES: 'masterclin_destaques',
};
